import { RESTDataSource } from "@apollo/datasource-rest";
import config from "@/lib/config";

class Recaptcha extends RESTDataSource {
  constructor(options) {
    super(options);
    this.context = options;
  }

  willSendRequest(_path, request) {
    request.headers["Content-Type"] = "application/x-www-form-urlencoded";
  }

  async recaptchaVerifyV2(recaptchaTokenV2) {
    const params = new URLSearchParams({
      secret: config.reCAPTCHASecretKey.v2,
      response: recaptchaTokenV2,
    }).toString();
    return this.post(config.recaptchaVerifyURL, {
      body: params,
    });
  }

  async recaptchaVerifyV3(recaptchaTokenV3) {
    const params = new URLSearchParams({
      secret: config.reCAPTCHASecretKey.v3,
      response: recaptchaTokenV3,
    }).toString();
    return this.post(config.recaptchaVerifyURL, {
      body: params,
    });
  }
}
export default Recaptcha;
